/**
 * Product Media Gallery Controls Repositioning
 * Moves Flickity dots and arrows outside the slider viewport for proper layout
 * TH-74: Ensure proper stacking order - images -> dots/arrows -> thumbnails
 */

(function() {
  'use strict';

  function moveFlickityControls(galleryElement) {
    // Find the controls container we added in the Liquid template
    const controlsContainer = galleryElement.closest('[data-media-viewer]')
      ?.querySelector('.f-product__media-controls');

    if (!controlsContainer) {
      console.warn('Product media controls container not found');
      return;
    }

    // Find Flickity-generated elements inside the slider
    const pageDots = galleryElement.querySelector('.flickity-page-dots');
    const prevButton = galleryElement.querySelector('.flickity-prev-next-button.previous');
    const nextButton = galleryElement.querySelector('.flickity-prev-next-button.next');

    // Move dots and arrows to the controls container
    if (pageDots) {
      controlsContainer.appendChild(pageDots);
      console.log('Moved flickity dots to controls container');
    }

    if (prevButton) {
      controlsContainer.appendChild(prevButton);
      console.log('Moved previous button to controls container');
    }

    if (nextButton) {
      controlsContainer.appendChild(nextButton);
      console.log('Moved next button to controls container');
    }

    // Add class to indicate controls have been relocated
    controlsContainer.classList.add('f-product__media-controls--initialized');
  }

  // Wait for media gallery to be loaded
  document.addEventListener('product-media:loaded', function(event) {
    const mediaGallery = event.target;
    const galleryElement = mediaGallery.querySelector('[id^="Media-Gallery"]');

    if (!galleryElement) return;

    // Wait a bit for Flickity to fully initialize and create controls
    setTimeout(() => {
      moveFlickityControls(galleryElement);
    }, 200);
  });

  // Fallback: also check on DOMContentLoaded in case the custom event doesn't fire
  document.addEventListener('DOMContentLoaded', function() {
    const galleries = document.querySelectorAll('[id^="Media-Gallery"]');

    galleries.forEach(gallery => {
      // Check if controls are already moved
      const controlsContainer = gallery.closest('[data-media-viewer]')
        ?.querySelector('.f-product__media-controls');

      if (controlsContainer && !controlsContainer.classList.contains('f-product__media-controls--initialized')) {
        // Wait for Flickity to initialize
        const checkInterval = setInterval(() => {
          const pageDots = gallery.querySelector('.flickity-page-dots');

          if (pageDots) {
            clearInterval(checkInterval);
            moveFlickityControls(gallery);
          }
        }, 100);

        // Clear interval after 5 seconds to prevent infinite checking
        setTimeout(() => clearInterval(checkInterval), 5000);
      }
    });
  });
})();

/**
 * ECSR-731: keep the selected PDP thumbnail (and its selection border) fully
 * in view on mobile.
 *
 * The thumbnail rail runs Flickity with freeScroll, so after a swipe it can
 * rest at any offset — including one where the selected thumbnail sits
 * partially past the viewport's left (or right) edge. Nothing corrects that:
 * the rail is only re-aligned by thumbnails.select(index) on a main-image
 * CHANGE (product-media.js), and selecting the already-active image is a
 * no-op, so the clipped state persists until the shopper pages the gallery.
 * The border overlay has only ~2.5px of breathing room (half the mobile
 * column gap), so any resting offset clips both the image and its border.
 *
 * Fix: after the rail settles, if the selected cell is not fully visible,
 * re-run the same select() alignment that gallery paging uses (cellAlign
 * left, animated). Mobile only — the desktop rail is out of scope per the
 * ticket and unchanged.
 */
(function () {
  'use strict';

  const mobileQuery = window.matchMedia('(max-width: 767.98px)');

  function attachGuard(rail) {
    const fk = rail.slider && rail.slider.instance;
    // The guard is keyed to the Flickity INSTANCE, not the element: some
    // templates destroy and rebuild the slider across the 768px boundary
    // (product-media.js match/unmatchMobile), and a fresh instance needs a
    // fresh settle listener.
    if (!fk || fk._ecsr731ClipGuard) return !!fk;
    fk._ecsr731ClipGuard = true;

    const realign = () => {
      if (!mobileQuery.matches) return;
      const viewport = rail.querySelector('.flickity-viewport');
      const cell = fk.selectedElement || (fk.selectedCell && fk.selectedCell.element);
      if (!viewport || !cell) return;
      const v = viewport.getBoundingClientRect();
      const c = cell.getBoundingClientRect();
      // 1px tolerance so sub-pixel rounding can't cause a re-align loop.
      if (c.left < v.left - 1 || c.right > v.right + 1) {
        fk.select(fk.selectedIndex);
      }
    };

    fk.on('settle', realign);
    // Also cover the initial paint (e.g. deep-linked variant media).
    realign();
    return true;
  }

  function guardThumbnailClipping(root) {
    const rail = (root.querySelector && root.querySelector('[id^="GalleryThumbnails"]')) || null;
    if (!rail) return;
    if (rail._ecsr731Polling) return; // one poll per rail at a time
    rail._ecsr731Polling = true;

    // flickity-component exposes its Flickity instance asynchronously.
    let tries = 0;
    const poll = setInterval(() => {
      if (attachGuard(rail) || ++tries > 50) {
        clearInterval(poll);
        rail._ecsr731Polling = false;
      }
    }, 100);
  }

  document.addEventListener('product-media:loaded', (event) => {
    guardThumbnailClipping(event.target);
  });
  document.addEventListener('DOMContentLoaded', () => {
    guardThumbnailClipping(document);
  });
  // Re-attach when the slider is rebuilt crossing the mobile breakpoint
  // (stacked/grid templates destroy the rail's Flickity on unmatchMobile
  // and create a new instance on matchMobile).
  document.addEventListener('matchMobile', () => {
    guardThumbnailClipping(document);
  });
})();
